import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Menu } from "lucide-react";

const links = [
  { label: "About me", href: "#about" },
  { label: "Track record", href: "#track-record" },
  { label: "Businesses", href: "#businesses", needs: "businesses" },
  { label: "AI apps", href: "#ai-apps", needs: "apps" },
  { label: "Expertise", href: "#expertise" },
  { label: "Press", href: "#press", needs: "press" },
  { label: "AI videos", href: "/content", needs: "videos" },
  { label: "Testimonials", href: "#testimonials" },
];

export const Navbar = ({ hasApps = false, hasBusinesses = false, hasPress = false, hasVideos = false }) => {
  const [open, setOpen] = useState(false);
  const visible = links.filter((l) => {
    if (!l.needs) return true;
    if (l.needs === "apps") return hasApps;
    if (l.needs === "press") return hasPress;
    if (l.needs === "videos") return hasVideos;
    return hasBusinesses;
  });

  return (
    <>
      <motion.header
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, delay: 1.4, ease: [0.76, 0, 0.24, 1] }}
        className="fixed top-0 left-0 right-0 z-50"
        data-testid="main-navbar"
      >
        <div className="px-5 lg:px-10 py-4 lg:py-5 flex items-center justify-between gap-4">
          <nav className="hidden md:flex flex-wrap gap-2 bg-[#EFEAE1]/70 backdrop-blur-md rounded-full p-1 -m-1">
            {visible.map((l) => (
              <a key={l.href} href={l.href} className="pill" data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </a>
            ))}
          </nav>
          <button
            onClick={() => setOpen(true)}
            className="pill md:hidden inline-flex items-center gap-2 bg-[#EFEAE1]/80 backdrop-blur-md"
            data-testid="mobile-menu-button"
          >
            <Menu size={15} /> Menu
          </button>
          <a href="#contact" className="pill pill--solid" data-testid="nav-contact-cta">
            Contact
          </a>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -24 }}
            transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
            className="fixed inset-0 z-[60] bg-[#EFEAE1] flex flex-col md:hidden"
            data-testid="mobile-menu-overlay"
          >
            <div className="px-5 py-4 flex items-center justify-between">
              <span className="font-giant text-2xl text-[#121110]">
                NAYAN V<span className="font-swash text-[#A8512E]">e</span>RMA
              </span>
              <button onClick={() => setOpen(false)} className="pill inline-flex items-center gap-2" data-testid="mobile-menu-close">
                <X size={15} /> Close
              </button>
            </div>
            <nav className="flex-1 flex flex-col justify-center px-5 gap-1">
              {visible.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.08 + i * 0.05, duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
                  className="font-giant text-4xl text-[#121110] py-3 border-b border-[#121110]/10"
                  data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </motion.a>
              ))}
              <motion.a
                href="#contact"
                onClick={() => setOpen(false)}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08 + visible.length * 0.05, duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
                className="font-giant text-4xl text-[#A8512E] py-3"
                data-testid="mobile-nav-link-contact"
              >
                Contact
              </motion.a>
            </nav>
            <p className="px-5 pb-8 font-swash text-xl text-[#A8512E]">slow introvert, magic results</p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
